module.exports = __webpack_public_path__ + "static/img/registerhome.a746329.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/registerhome.png
// module id = 371
// module chunks = 22